module.exports = __webpack_public_path__ + "img/icon_order2.a62d5dd3.svg";